import React, { useContext, useEffect } from 'react';
import Button from '@carvana/showroom-forms/Button/Primary';
import { AnalyticsContext } from '@carvana/eventable-clickstream';
import { datadogRum } from '@datadog/browser-rum';
import { Wrapper, BoldText, TextBox, ButtonContainer } from './style';
import ThinCheckmarkIcon from '../../assets/images/ThinCheckmarkIcon';
import { eventableTypes } from '../../constants';
import { AsrAnalytics } from '../../../../../constants';

type CosmeticConfirmationProps = {
  closeModal: () => void;
};

const CosmeticConfirmation = ({ closeModal }: CosmeticConfirmationProps) => {
  const { trackEvent } = useContext(AnalyticsContext);

  useEffect(() => {
    trackEvent(AsrAnalytics.COS_VIEWED_SUCCESS);
    datadogRum.addAction(AsrAnalytics.COS_VIEWED_SUCCESS);
  }, []);

  return (
    <Wrapper>
      <ThinCheckmarkIcon />
      <BoldText>Thank you!</BoldText>
      <TextBox>
        <p>You have successfully submitted your vehicle concern!</p>
        <p>We&apos;re sorry we hit a speed bump with your vehicle, but we&apos;re here to help!</p>
        <p>We have sent this information to our warranty administrator, SilverRock&trade;, for review. SilverRock&trade; will reach out to you via email within 24 hours with a decision and possible next steps.</p>
      </TextBox>
      <ButtonContainer>
        <Button
          onClick={() => {
            trackEvent(eventableTypes.confirmationScreen);
            closeModal();
          }}
        >
          OK
        </Button>
      </ButtonContainer>
    </Wrapper>
  );
};

export default CosmeticConfirmation;
